
import React, { useReducer, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
    encounterReducer,
    initialState as encountersInitialState
} from "../reducers/encounterReducer";
import { nedocsReducer, initialNedocs } from "../reducers";
import { hospitalActions } from "../actions";
import { useInternationalization } from "../hooks/useInternationalization";
import { encounterActions } from "../actions/encounterActions";
import { GENERAL_STATUS_COSTANTS } from "../utils/jsCostants";
import { findUrgencyCodeDescriptionId } from "../utils/findUrgencyByCode";
import { Loader } from "../components/Loader";
import { BodyMonitoraggioTotem } from "../components/BodyMonitoraggioTotem";

export const MonitoraggioTotem = ({ history, id }) => {
    const [encounterState, dispatch] = useReducer(encounterReducer, encountersInitialState);

    const firstEncounter = encounterState.encounters.length > 0 ?
        encounterState.encounters[0] :
        undefined;

    const [currentTime, setCurrentTime] = useState(0);
    const [description, setDescription] = useState("");
    const [generalStatus, setGeneralStatus] = useState("");

    const [nedocsStatus, updateNedocs] = useReducer(nedocsReducer, initialNedocs);

    const { locale } = useInternationalization();
    const intl = useIntl();

    useEffect(() => {
        hospitalActions.hospitalNedocs("20700", updateNedocs, intl);
    }, [intl]);

    const callbackActionReducerEncounter = () => {
        encounterActions.addEncounter(id, locale, dispatch, intl);
    };

    useEffect(() => {
        setCurrentTime(0);
        const time = setInterval(() => {
            setCurrentTime(prevTime => prevTime + 1);
        }, 60000)
        return (() => {
            clearInterval(time);
        })
    }, [firstEncounter]);

    useEffect(() => {
        encounterActions.addEncounter(id, locale, dispatch, intl);
    }, [id, locale]);

    useEffect(() => {
        if (firstEncounter && firstEncounter.hasOwnProperty("code")) {
            const { code: { code }, generalStatus: genStatus, generalStatusDisplay } = firstEncounter;
            if (Number.parseInt(code) !== -1) {
                setDescription(intl.formatMessage({ id: findUrgencyCodeDescriptionId(code) }));
            }
            setGeneralStatus(
                (genStatus === GENERAL_STATUS_COSTANTS.NOT_AVAILABLE || genStatus === GENERAL_STATUS_COSTANTS.NOT_YET_AVAILABLE) ?
                    intl.formatMessage({ id: 'monitoraggioPazientePage.inElaborazione' })
                    :
                    generalStatusDisplay
            )
        }
    }, [firstEncounter, id, locale]);

    if (nedocsStatus.pristine || nedocsStatus.error) {
        return null;
    }
    if (nedocsStatus.loading) {
        return <Loader />;
    } else if (encounterState.loading) {
        return <Loader overlay />;
    }
    return (
        < BodyMonitoraggioTotem
            history={history}
            nedocsValue={nedocsStatus.nedocs.value}
            firstEncounter={firstEncounter}
            currentTime={currentTime}
            description={description}
            generalStatus={generalStatus}
            callbackOnRenewSession={callbackActionReducerEncounter} />
    );
}